import { Component, OnInit } from "@angular/core";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { ProcessEditorComponent } from "@app/process-editor/process-editor.component";

@Component({
    selector: "app-process-overview",
    templateUrl: "./process-overview.component.html",
    styleUrls: ["./process-overview.component.scss"],
    imports: [ProcessEditorComponent],
})
export class ProcessOverviewComponent implements OnInit {
    public tab: TabModel;

    constructor() {}

    ngOnInit() {}
}
